/**
 * Cookie apex for the current host so preference cookies are shared across its subdomains.
 * Derived from the hostname only — no deploy-specific domain names in the bundle.
 */
export function getApexCookieDomain(hostname: string): string | undefined {
  const labels = hostname.split('.')
  if (labels.length < 2 || /^[\d.]+$/.test(hostname)) {
    return undefined
  }
  return `.${labels.slice(-2).join('.')}`
}

/** Domain attributes that may hold a shadowing copy of a preference cookie. */
export function getCookieDomainCandidates(hostname: string): string[] {
  const labels = hostname.split('.')
  return labels.map((_, i) => labels.slice(i).join('.')).filter(domain => domain.includes('.'))
}
